export default __webpack_public_path__ + "static/media/0xf6a637525402643b0654a54bead2cb9a83c8b498.abd291a4.svg";